import { render, staticRenderFns } from "./EdgeboardTasktypeConfigList.vue?vue&type=template&id=377f4678&scoped=true&"
import script from "./EdgeboardTasktypeConfigList.vue?vue&type=script&lang=js&"
export * from "./EdgeboardTasktypeConfigList.vue?vue&type=script&lang=js&"
import style0 from "./EdgeboardTasktypeConfigList.vue?vue&type=style&index=0&id=377f4678&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377f4678",
  null
  
)

export default component.exports